var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { ThemeProvider as BaseThemeProvider, createGlobalStyle } from 'styled-components';
import * as THEME from '../themes/colors';
import { CLASS_DIALOG_MOVING_ATTR_NAME, CLASS_MODAL_INERT_ATTR_NAME } from "../helpers/attributes";
var GlobalStyles = createGlobalStyle(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    [", "] {\n        cursor: move;\n    }\n\n    [", "] {\n        pointer-events: none;\n        cursor: default;\n    }\n\n    [", "], [", "] * {\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n    }\n"], ["\n    [", "] {\n        cursor: move;\n    }\n\n    [", "] {\n        pointer-events: none;\n        cursor: default;\n    }\n\n    [", "], [", "] * {\n        user-select: none;\n        -webkit-user-select: none;\n        -moz-user-select: none;\n        -ms-user-select: none;\n    }\n"])), CLASS_DIALOG_MOVING_ATTR_NAME, CLASS_MODAL_INERT_ATTR_NAME, CLASS_MODAL_INERT_ATTR_NAME, CLASS_MODAL_INERT_ATTR_NAME);
export var ThemeProvider = function (_a) {
    var _b = _a.theme, theme = _b === void 0 ? THEME.blue : _b, children = _a.children, rest = __rest(_a, ["theme", "children"]);
    return (React.createElement(BaseThemeProvider, __assign({}, rest, { theme: theme }),
        React.createElement(GlobalStyles, null),
        children));
};
var templateObject_1;
//# sourceMappingURL=ThemeProvider.js.map